<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Chips</strong></h4>
      <a href="https://mdbootstrap.com/vue/components/badges/#chips-avatars/?utm_source=DemoApp&utm_medium=MDBVuePro" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr class="mb-5" />
    <container class="mt-5">
      <h2>Chips with avatars</h2>
      <chip src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg" alt="Contact Person" waves> John Doe</chip>
      <chip src="https://mdbootstrap.com/img/Photos/Avatars/avatar-10.jpg" alt="Contact Person" size="md" waves> Anna Smith</chip>
      <chip src="https://mdbootstrap.com/img/Photos/Avatars/avatar-5.jpg" alt="Contact Person" size="lg" waves> Lara Lim</chip>

      <hr class="my-5"/>
      <h2>Chips without avatars</h2>
      <chip color="pink lighten-4" close> Tag 220 </chip>

      <hr class="my-5"/>
      <h2>Chips with various colors</h2>
      <chip src="https://mdbootstrap.com/img/Photos/Avatars/img(7).jpg" alt="Contact Person"> Caroline Smith</chip>
      <chip src="https://mdbootstrap.com/img/Photos/Avatars/img(28).jpg" alt="Contact Person" color="cyan darken-2" text="white" size="md"> Martha Lores</chip>
      <chip src="https://mdbootstrap.com/img/Photos/Avatars/img(21).jpg" alt="Contact Person" color="success-color" text="white" size="lg">The Sylvester</chip>
      <chip color="teal lighten-2" text="white" close>Martha</chip>
      <chip color="indigo lighten-4" text="indigo" size="md" close>24.08.2016</chip>
      <chip gradient="aqua" text="white" size="lg" close>Aqua gradient</chip>

      <hr class="my-5"/>
      <h2>Chip input</h2>
      <chip-input placeholder="+Tag" secondaryPlaceholder="Enter a tag"/>
      <chip-input :chips="['Tag 1','Tag 2','Tag 3']"/>

    </container>
  </container>
</template>

<script>
import { Container, Chip, ChipInput, Fa, Row } from 'mdbvue';

export default {
  components: {
    Container,
    Chip,
    ChipInput,
    Fa,
    Row
  }
};

</script>

<style>
</style>
